// extracted by mini-css-extract-plugin
export default {"item-list":"DesktopSubItems_item-list__np6AR"};